module.exports = {
  'i18n-demo': {
    message: {
      title: 'Sport Brands<br/> top 5'
    },
    placeholder: {
      enter: 'Please type in your favorite brand'
    },
    brands: {
      nike: 'Nike',
      adi: 'Adidas',
      nb: 'New Banlance',
      ln: 'LI Ning',
      at: 'Anta'
    },
    love: 'I like {brand}',
    label_date: 'Now is: '
  }

}



// WEBPACK FOOTER //
// ./src/lang/i18n-demo/en-US.js